import { CHATWERK_LOADER_URL } from './chat-widget.constants';
import type { ChatwerkConfig, ChatwerkLoader } from './chatwerk.types';

let pending: Promise<ChatwerkLoader> | null = null;
let started = false;

function injectLoader(): Promise<ChatwerkLoader> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = CHATWERK_LOADER_URL;
        script.async = true;
        script.onload = () => {
            if (window.chatwerkLoader) resolve(window.chatwerkLoader);
            else reject(new Error('ChatWerk loader did not register'));
        };
        script.onerror = () => {
            script.remove();
            reject(new Error('ChatWerk loader failed to load'));
        };
        document.head.appendChild(script);
    });
}

/** Loads the script once; after a failure the next click tries again. */
function loadChatwerk(): Promise<ChatwerkLoader> {
    pending ??= injectLoader().catch((error: unknown) => {
        pending = null;
        throw error;
    });

    return pending;
}

/** True once ChatWerk handles the launcher's clicks itself. */
export const isChatwerkStarted = (): boolean => started;

/**
 * Initializes ChatWerk on the launcher and opens the chat for the click that
 * started it: ChatWerk only binds its handler during initialize, so that first
 * click would otherwise go unanswered.
 */
export async function startChatwerk(config: ChatwerkConfig, launcher: HTMLElement): Promise<void> {
    const loader = await loadChatwerk();
    if (started) return;

    loader.initialize(config);
    started = true;
    launcher.click();
}
